import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countdown'
})
export class CountdownPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null || value < 0) return '0:00:00';

    const days = Math.floor(value / (24 * 3600));
    const hours = Math.floor((value % (24 * 3600)) / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = value % 60;

    const daysStr = days > 0 ? `${days} days, ` : '';
    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    const secondsStr = seconds.toString().padStart(2, '0');

    return `${daysStr}${hoursStr}:${minutesStr}:${secondsStr}`;
  }
}